var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7897 6.68359H7.81607V3.70996C7.81607 3.39844 7.56119 3.14355 7.24966 3.14355C6.93814 3.14355 6.68326 3.39844 6.68326 3.70996V6.68359H3.70963C3.3981 6.68359 3.14322 6.93848 3.14322 7.25C3.14322 7.56152 3.3981 7.81641 3.70963 7.81641H6.68326V10.79C6.68326 11.1016 6.93814 11.3564 7.24966 11.3564C7.56119 11.3564 7.81607 11.1016 7.81607 10.79V7.81641H10.7897C11.1012 7.81641 11.3561 7.56152 11.3561 7.25C11.3561 6.93848 11.1012 6.68359 10.7897 6.68359Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.83d147bf1dd92d724a0b4ef2e85cfc4f.svg";
export { ForwardRef as ReactComponent };